<template>
  <row class="amendments-list" :gutter="16" type="flex" align="top">
    <i-col span="8" v-for="amendment in amendments" :key="amendment.id">
      <amendments-item @edit="handleEdit" :amendment="amendment" />
    </i-col>
  </row>
</template>

<script>
import AmendmentsItem from './amendments-item'

export default {
  props: ['amendments'],
  components: {
    AmendmentsItem
  },
  methods: {
    handleEdit (amendment) {
      this.$emit('edit', amendment)
    }
  }
}
</script>

<style>
</style>
